import React from 'react';
import { Box, Grid } from '@mui/material';
import { CreatableSelect } from 'components/campaigns/CreatableSelect';
import { CustomerSegment } from 'components/customers/models/Customer';
import { Option } from 'lib/types';

interface AddAudienceEffectProps {
    value: Option;
    onChange: (value: Option) => void;
    onCreate: (title: string) => void;
    audiences: CustomerSegment[];
}

export const AddAudienceEffect: React.FC<AddAudienceEffectProps> = ({
    value,
    onChange,
    onCreate,
    audiences
}) => {
    const options = React.useMemo(
        () => audiences.map(item => ({ label: item.title, value: item._id })),
        [audiences]
    );
    return (
        <Grid item>
            <Box minWidth={300}>
                <CreatableSelect
                    placeholder={'Select audience or start typing...'}
                    value={value}
                    onChange={onChange}
                    options={options}
                    onCreate={onCreate}
                />
            </Box>
        </Grid>
    );
};
